import { cognitoLogin } from "../services/cognito";
import { getElementById } from "../services/dom";
import loginTemplate from "../templates/pages/login.html?raw";
import { Page } from "./base";
import logoUrl from "../assets/logo.png";

export default class LoginPage extends Page {
  private loginForm: HTMLFormElement;
  constructor() {
    super(loginTemplate)
    this.loginForm = getElementById("loginForm") as HTMLFormElement;
    this.loadPage();
  }

  private loadPage(): void {
    const logoElement = getElementById("section-logo");
    const logoImg = document.createElement("img");
    logoImg.src = logoUrl;
    logoImg.alt = "Logo";
    logoElement.appendChild(logoImg);

    this.loginForm.addEventListener("submit", () => this.submitLoginForm());
    super.handleCustomAttributes();
  }

  private async submitLoginForm() {
    const formData = new FormData(this.loginForm);
      const username = formData.get("username") as string;
      const password = formData.get("password") as string;
      await cognitoLogin(username, password);
      window.location.href = "/";
  }
}
